const shippingAllTimeValues = {
  baseline: {
    value: 35.8,
    standardError68: 0.5,
    standardError95: 1.1,
  },
  periods: [
    {
      timestamp: 1696118400000,
      countEventsPerformable: 206,
      countEventsPerformed: 85,
      value: {
        value: 37.4,
        standardError68: 3.1,
        standardError95: 6,
      },
      valueChangeFromBaseline: {
        value: 1.6,
        standardError68: 3.1,
        standardError95: 6.1,
      },
    },
    {
      timestamp: 1698796800000,
      countEventsPerformable: 182,
      countEventsPerformed: 66,
      value: {
        value: 36.3,
        standardError68: 3.6,
        standardError95: 7,
      },
      valueChangeFromBaseline: {
        value: 0.5,
        standardError68: 3.6,
        standardError95: 7.1,
      },
    },
    {
      timestamp: 1701388800000,
      countEventsPerformable: 246,
      countEventsPerformed: 92,
      value: {
        value: 41.3,
        standardError68: 3.4,
        standardError95: 6.7,
      },
      valueChangeFromBaseline: {
        value: 5.5,
        standardError68: 3.5,
        standardError95: 6.8,
      },
    },
  ],
};

export const getBehaviourSuccessRateOverTimeRespMaritime = () => {
  let data = shippingAllTimeValues;
  return data;
};
